import { BriefcaseBusiness, Building, ShieldCheck, UserRound, UsersRound } from "lucide-react";

export const COMMUNITY = "communityId";
export const PROPERTY = "propertyId";
export const OWNERSHIP_TYPE = "ownershipType";
export const USERS = "propertyUserAssociations";
export const NEW_USER = "newUser";
export const USER_TYPE = "userType";
export const USERNAME = "userName";
export const ALTERNATE_LOGIN_ID = "loginId";
export const FIRST_NAME = "firstName";
export const LAST_NAME = "lastName";
export const MOBILE_NO = "phoneNumber";
export const LANDLINE_NO = "landlineNumber";
export const EMAIL_ID_1 = "email";
export const EMAIL_ID_2 = "email2";
export const ADDRESS = "address";
export const ADDRESS_1 = "addressLine1";
export const ADDRESS_2 = "addressLine2";
export const ZIPCODE = "zipCode";
export const STATE = "state";
export const CITY = "city";
export const PO_BOX = "pobox";
export const OWNERSHIP_SHARE = "sharePercentage";
export const USER_ID = "userId";
export const OCCUPANCY_TYPE = "associationType";
export const START_DATE = "startDate";
export const END_DATE = "endDate";
export const IS_BOM_USER = "isBomUser";
export const BOM_START_DATE = "bomStartDate";
export const BOM_END_DATE = "bomEndDate";
export const BOM_POSITION = "bomPositionId";
export const CORRESPONDENCE_ADDRESS = "correspondenceAddress";
export const MULTI_CORRESPOND = "multiCorrespond";
export const PRIMARY_USER = "primaryUser";
export const ORGANIZATION_NAME = "organization";
export const ROW_INDEX = "rowIndex";
export const CUSTOM_ADDRESS = "customAddress";

export const EXISTING = "existing";
export const NEW = "new";

export const OWNER = "OWNER";
export const TENANT = "TENANT";
export const LANDLORD = "LANDLORD";
export const PROPERTY_MANAGER = "PROPERTY_MANAGER";

export const occupancyTypes = [
  { label: "Owner", value: OWNER },
  { label: "Tenant", value: TENANT },
  { label: "Landlord", value: LANDLORD },
  { label: "Property Manager", value: PROPERTY_MANAGER },
];

export const INDIVIDUAL = "INDIVIDUAL";
export const JOINT = "JOINT";
export const LLC = "LLC";
export const TRUST = "TRUST";
export const CORP = "CORP";

export const ownershipTypeOptions = [
  {
    id: 1,
    label: 'Individual',
    value: INDIVIDUAL,
    icon: UserRound
  },
  {
    id: 2,
    label: 'Joint',
    value: JOINT,
    icon: UsersRound
  },
  {
    id: 3,
    label: 'LLC',
    value: LLC,
    icon: Building
  },
  {
    id: 4,
    label: 'Trust',
    value: TRUST,
    icon: ShieldCheck
  },
  {
    id: 5,
    label: 'Corp',
    value: CORP,
    icon: BriefcaseBusiness
  },
]

export const orgOwnershipType = [LLC, TRUST, CORP];

export const addressCorrespondOptions = [
  {
    title: 'Property address',
    subTitle: 'Property Master',
    text1: '(select a property)',
    text2: '↳ Maps to the property — auto-updates if it changes',
    value: 'property'
  },
  {
    title: 'Owner\'s primary address',
    subTitle: 'Owner Master',
    text1: '(enter owner address)',
    text2: '↳ Maps to the primary owner — auto-updates if it changes',
    value: 'owner'
  },
  {
    title: 'Custom address',
    subTitle: 'Property Ownership',
    text1: 'A different address used only for this ownership — stored on the title itself.',
    text2: '↳ Stored in Property Ownership only',
    value: "custom"
  }
]

// {
//   "address": {
//     "addressLine1": "fas",
//     "addressLine2": "",
//     "city": "Phoenix",
//     "pobox": "123",
//     "state": "CA",
//     "zipCode": "12345"
//   },
//   "correspondenceAddress": "property",
//   "email": "poojakahar2495@gmail.com",
//   "email2": "",
//   "endDate": "",
//   "firstName": "Me",
//   "landlineNumber": "",
//   "lastName": "Kahar",
//   "loginId": "ALTME",
//   "multiCorrespond": false,
//   "associationType": "OWNER",
//   "primaryUser": true,
//   "ownershipShare": "",
//   "phoneNumber": "8979797979",
//   "startDate": "2026-08-11T00:00:00",
//   "userName": "USERME",
//   "userType": "new",
//   "userId": ""
// }, 
// {
//   "address": {
//     "addressLine1": "fas",
//     "addressLine2": "",
//     "city": "Phoenix",
//     "pobox": "123",
//     "state": "CA",
//     "zipCode": "12345"
//   },
//   "correspondenceAddress": "property",
//   "email": "poojakahar2495@gmail.com",
//   "email2": "",
//   "endDate": "",
//   "firstName": "Me",
//   "landlineNumber": "",
//   "lastName": "Kahar",
//   "loginId": "ALTME",
//   "multiCorrespond": false,
//   "associationType": "TENANT",
//   "ownershipShare": "",
//   "phoneNumber": "8979797979",
//   "startDate": "2026-08-11T00:00:00",
//   "userName": "USERME",
//   "userType": "new",
//   "user_id": ""
// }